import React from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'
import classNames from 'classnames'

import getTimeString from './get-time-string'
import play from '../../../../../../images/new-play.svg'
import replay from '../../../../../../images/new-replay.svg'
import Button from '../../../../button'
import styles from './playback-info.css'

function PlaybackInfo({ playbackInfo, wrapperClassName }) {
  const { numberMinutesRemaining, numberMinutesWatched } = playbackInfo
  const time = getTimeString(numberMinutesRemaining)
  const totalTime = numberMinutesWatched + numberMinutesRemaining

  const progressBar = () => {
    const progress = totalTime > 0 ? numberMinutesWatched / totalTime : 0
    const isWatched = playbackInfo.status === 'FINISHED'
    return (
      <div className={styles.progressTube}>
        <div
          className={classNames(
            styles.progressBar,
            {
              // Apply a primary color to progress bar when episode is fully watched
              [styles.watchedProgressBar]: isWatched
            }
          )}
          style={{ width: isWatched ? '100%' : `${progress * 100}%` }}
        />
      </div>
    )
  }

  switch (playbackInfo.status) {
    case 'IN_PROGRESS': {
      return (
        <div className={classNames(wrapperClassName, styles.wrapper)}>
          <div className={styles.timeWrapper}>
            <div className={styles.timeDisplay}>
              {time}
              {' '}
              remaining
            </div>
          </div>
          {progressBar()}
        </div>
      )
    }

    case 'FINISHED':
      return (
        <div className={classNames(wrapperClassName, styles.wrapper)}>
          <div className={styles.timeWrapper}>
            <Button
              className={styles.iconWrapper}
              darkBGSecondary
            >
              <ReactSVG
                src={replay}
                beforeInjection={(svg) => {
                  svg.setAttribute('class', classNames(styles.icon, styles.replayIcon))
                }}
              />
            </Button>
            <div className={styles.timeDisplay}>{time}</div>
          </div>
          {progressBar()}
        </div>
      )

    // use 'NOT_STARTED' as default scenario
    default:
      return (
        <div className={classNames(wrapperClassName, styles.wrapper)}>
          <div className={styles.timeWrapper}>
            <Button
              className={styles.iconWrapper}
              darkBGSecondary
            >
              <ReactSVG
                src={play}
                beforeInjection={(svg) => {
                  svg.setAttribute('class', classNames(styles.icon, styles.playIcon))
                }}
              />
            </Button>
            <div className={styles.timeDisplay}>{time}</div>
          </div>
        </div>
      )
  }
}

PlaybackInfo.propTypes = {
  playbackInfo: PropTypes.shape({
    status: PropTypes.string.isRequired,
    numberMinutesRemaining: PropTypes.number.isRequired,
    numberMinutesWatched: PropTypes.number.isRequired
  }).isRequired,
  wrapperClassName: PropTypes.string.isRequired
}

export default PlaybackInfo
